import React, { ReactElement } from 'react';
import ReactTooltip from 'react-tooltip';
import './Tooltip.scss';
import { findDOMNode } from 'react-dom';

interface ITooltip {
  children: ReactElement,
  id?: string
  place: ReactTooltip.Place,
  type?: "default" | "blue",
  className?: string
}

class Tooltip extends React.PureComponent<ITooltip, any> {
  tooltip: ReactTooltip | null = null;


  /**
  * function to handle the click outside the element and close the tooltip consequetly
  */
  handleClickOutside = (evt: any) => {
    const domNode: any = findDOMNode(this);
    if (!domNode || !domNode.contains(evt.target)) {
      const tooltip = (findDOMNode(this.tooltip) as any);
      if (tooltip.className.indexOf("show") >= 0) {
        tooltip.className = tooltip.className.replace(/show/g, "");;
      } else {
        tooltip.className += "show";
      }
    }
  }

  componentDidMount() {
    // document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    // document.removeEventListener('click', this.handleClickOutside, true);
  }

  render() {
    const { children, id, place, type = "default", className = "", ...rest } = this.props;

    return (
      <ReactTooltip
        {...rest}
        ref={ref => this.tooltip = ref}
        // iscapture propagate the event to the children! necessary if we have clickable lists inside the tooltip
        isCapture
        className={`tooltip tooltip--${type} ${className}`}
        type='light'
        place={place}
        id={id}
        globalEventOff="click"
        scrollHide={false}
      >
        {children}
      </ReactTooltip>
    );
  }
}

export default Tooltip;